import { includes, intersection } from 'lodash-es';

import type { AuthState } from 'common/auth/types';
import { RoleVariantEnum } from 'common/graphql/types';

const hasPermission = (auth: AuthState, requiredPermissions: string[] = []): boolean => {
    const userPermissions: string[] = auth.activeUser.permissions;
    const hasPermission = !requiredPermissions.length || intersection(requiredPermissions, userPermissions).length;

    return !!hasPermission;
};

export const checkPermissions = ({
    permissions = [],
    auth,
}: {
    permissions?: string[];
    auth?: AuthState | null;
}): boolean | undefined => {
    return auth?.activeUser && hasPermission(auth, permissions);
};
const hasRoles = (auth: AuthState, requiredRole: string[] = [], permissions: string[] = []): boolean => {
    if (
        (auth.activeUser?.roleVClaim && auth.activeUser?.roleVClaim?.sk) ||
        (auth.activeUser?.roleBClaim && auth.activeUser?.roleBClaim?.sk)
    ) {
        const roleId =
            auth.activeUser?.roleVClaim?.sk ||
            (auth.activeUser?.roleBClaim?.sk && auth.activeUser?.role === RoleVariantEnum.SystemAdministrator
                ? auth.activeUser?.role // since base role id of sysadmin and subadmin are same, differentiating with role attribute
                : auth.activeUser?.roleBClaim?.sk);
        //Checked role and Permission
        if (requiredRole?.length && permissions?.length) {
            const isCheckUserPermissions = hasPermission(auth, permissions);

            return includes(requiredRole, roleId) && isCheckUserPermissions;
        } else {
            return includes(requiredRole, roleId);
        }
    } else {
        return hasPermission(auth, permissions);
    }
};

interface CheckRolesParams {
    roles?: string[];
    auth?: AuthState | null;
    permissions?: string[];
}

export const checkRoles = ({ roles = [], auth = null, permissions = [] }: CheckRolesParams): boolean => {
    return !!auth?.activeUser && hasRoles(auth, roles, permissions);
};

export const isUserLoggedIn = (authContext): boolean => authContext != null && authContext.activeUser != null;
